import React, { type ComponentPropsWithoutRef } from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';
import type { BannerAnnouncement as BannerAnnouncementType } from './banner-v2/BannerAnnouncement.tsx';

const BannerAnnouncement = lazyAfterPaint<typeof BannerAnnouncementType>(
	() =>
		import(
			/* webpackChunkName: "async-platform-ui-banners-announcement-v2" */ './banner-v2/BannerAnnouncement.tsx'
		).then((module) => module.BannerAnnouncement),
	// eslint-disable-next-line jira/entry-fs/restrict-shell-only-to-navigation-apps
	{ ssr: true, entryFsSsrLiftImportToModule: true, includeInShellOnlySsrBundle: true },
);

export const BannerAnnouncementAsync = (
	props: ComponentPropsWithoutRef<typeof BannerAnnouncement>,
) => (
	<Placeholder name="async-platform-ui-banners-announcement" fallback={null}>
		<BannerAnnouncement {...props} />
	</Placeholder>
);
